import React from 'react';
import { STATIC_ICONS, defaultIcon } from '../../Constants';
import TemplateDetailsHeaderActions from './TemplateDetailsHeaderActions';

const TemplateDetailsHeader = ({
    t,
    details,
    edit,
    loading,
    alert,
    navigate,
    isDashboardExpandedActive,
    canOpenReportDialog,
    canAddTemplate,
    canAddTemplateExamples,
    isCompactHeaderActions,
    isHeaderActionsMenuOpen,
    setIsHeaderActionsMenuOpen,
    headerActionsMenuRef,
    downloadReportActionLabel,
    setDownloadReportState,
    duplicateTemplate,
    openMarkAsExampleDialog,
    handleCancelEdit,
    isApplyDisabled,
    updateTemplate,
    setEdit,
}) => (
    <div className={`details-head${isDashboardExpandedActive ? ' dashboard-edit-expanded-head' : ''}`}>
        <img
            alt="icon"
            src={`${STATIC_ICONS}${
                details.icon?.length > 0 ? details.icon : defaultIcon
            }`}
        />

        <div className="details-remain-head" style={{ width: '100%' }}>
            <div
                className="details-remain-head-part"
                style={{ justifyContent: 'space-between', alignItems: 'center' }}
            >
                <div className="details-head-left">
                    <h1>{details.name}</h1>
                    {details.templateExample ? (
                        <div className="td-linked-example-chip">
                            <span className="td-linked-example-chip__label">
                                {t.attachedExampleChipLabel || 'Example'}
                            </span>
                            <span className="td-linked-example-chip__name">
                                {details.templateExample.example_name ||
                                    details.templateExample.name ||
                                    `#${details.templateExample.template_example_id}`}
                            </span>
                        </div>
                    ) : null}
                </div>
                <TemplateDetailsHeaderActions
                    t={t}
                    details={details}
                    edit={edit}
                    loading={loading}
                    alert={alert}
                    navigate={navigate}
                    canOpenReportDialog={canOpenReportDialog}
                    canAddTemplate={canAddTemplate}
                    canAddTemplateExamples={canAddTemplateExamples}
                    isCompactHeaderActions={isCompactHeaderActions}
                    isHeaderActionsMenuOpen={isHeaderActionsMenuOpen}
                    setIsHeaderActionsMenuOpen={setIsHeaderActionsMenuOpen}
                    headerActionsMenuRef={headerActionsMenuRef}
                    downloadReportActionLabel={downloadReportActionLabel}
                    setDownloadReportState={setDownloadReportState}
                    duplicateTemplate={duplicateTemplate}
                    openMarkAsExampleDialog={openMarkAsExampleDialog}
                    handleCancelEdit={handleCancelEdit}
                    isApplyDisabled={isApplyDisabled}
                    updateTemplate={updateTemplate}
                    setEdit={setEdit}
                />
            </div>
        </div>
    </div>
);

export default TemplateDetailsHeader;
